'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = require('react');

var _constant = require('../constant');

//  weak

function computeIndex(params) {
  var children = params.children;
  var indexLatest = params.indexLatest;
  var startX = params.startX;
  var pageX = params.pageX;
  var viewLength = params.viewLength;
  var resistance = params.resistance;


  var indexMax = _react.Children.count(children) - 1;
  var index = indexLatest + (startX - pageX) / viewLength;
  var newStartX = void 0;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - indexLatest) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - indexLatest) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/lib/utils/computeIndex.js
// module id = 329
// module chunks = 0